module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HULL","short_name":"HULL","start_url":"/","background_color":"#000","theme_color":"#000","icon":"src/img/apple-touch-icon.png","include_favicon":false,"cache_busting_mode":"query","legacy":true,"theme_color_in_head":true,"cacheDigest":"5bce5535ba7a56396885ede842173688"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
